
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pupils/lessons/[lessonSlug]/video",
      function () {
        return require("private-next-pages/pupils/lessons/[lessonSlug]/video.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pupils/lessons/[lessonSlug]/video"])
      });
    }
  